import { defineCustomElement } from '@tyler-components-web/core';
import { SwitchComponent } from './switch';
export * from './switch-constants';
export * from './switch';
export function defineSwitchComponent() {
    defineCustomElement(SwitchComponent);
}
